<template>
    <div class="horizontal-tab">
        <div class="card card-with-shadow border-0">
            <nav>
                <div class="nav nav-tabs">
                    <a v-for="(tab, index) in filteredTab" :key="index"
                       class="nav-item p-primary"
                       :class="{'active':currentIndex == index}"
                       data-toggle="tab" :href="'#'+tab.name+'-'+index"
                       @click.prevent="loadComponent(tab,index)">
                        {{$t(tab.name)}}
                    </a>
                </div>
            </nav>
            <div class="tab-content p-primary">
                <div class="tab-pane fade show active" :id="componentId">
                    <app-overlay-loader v-if="preLoader" />
                    <div class="content" v-else>
                        <div class="row mb-2">
                            <div class="deals-chart-height-min col-12">
                                <app-chart class="mb-2" type="bar-chart" :height="500" :labels="chart.labels"
                                    :data-sets="chart.dataSet" />
                            </div>
                          
                            <div class="chart-data-list col-12 d-flex flex-wrap justify-content-center">
                                <div class="data-group-item">
                                    <span class="value"><span class="font-weight-bold">{{ $t("tabdate") }}: {{ (tabdate.qty == 1) ? numberWithCurrencyMuseum(chart.total) : chart.total }}</span></span>
                                </div>
                            </div>
                        </div>
                 
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {TabMixin} from './mixins/TabMixin';
import { formatDateToLocal, formatDateTimeToLocal, numberWithCurrencySymbol, numberWithCurrencyMuseum } from "@app/Helpers/helpers";
export default {
    name: "AppTab",
    mixins: [TabMixin],
    data() {
            return {
				formatDateToLocal,
                numberWithCurrencySymbol,
                numberWithCurrencyMuseum

                
            }
        },
}
</script>

<style>
	
	
</style>


